import { useGet, useQueryWithErrorHandling } from '@app/sdk';
import { Brand } from '@app/models';
import { brandBaseUrl } from '../BaseUrls';

const pillarCode = "tms";

export function useGetBrand({ id }: { id: string }) {
  const get = useGet(true, pillarCode);
  return useQueryWithErrorHandling({
    queryKey: ['get-brand', id],
    queryFn: async () => await get<Brand>(`${brandBaseUrl}/brands/${id}`),
    enabled: !!id,
  });
}